export const REFERRAL_CODE_STORAGE_KEY = "referralCode";

/**
 * Referral codes arrive from an attacker-controllable `?code=` link, are persisted
 * indefinitely, and end up inside a signed on-chain transaction
 * (tx.pure.string(referralCode) in the purchase flow). Validate before storing:
 * anything that is not a plausible code should never reach that sink, and an
 * unbounded value would also blow the localStorage quota and crash the page.
 */
export const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]{1,32}$/;

export function isValidReferralCode(code: unknown): code is string {
  return typeof code === "string" && REFERRAL_CODE_PATTERN.test(code);
}

/**
 * Persist a referral code, returning whether it was accepted.
 * Wrapped because `setItem` throws when storage is full or blocked (Safari
 * private mode), which would otherwise propagate out of a React effect and trip
 * the error boundary.
 */
export function storeReferralCode(code: unknown): boolean {
  if (!isValidReferralCode(code)) return false;

  try {
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, code);

    return true;
  } catch {
    return false;
  }
}
